import { __awaiter, __generator } from "tslib";
import { AddToCartActionOption } from '@wix/wixstores-client-core';
export function preloadCartByAction(ecomPlatformPublicAPI, action) {
    if (action === AddToCartActionOption.TINY_CART) {
        return ecomPlatformPublicAPI.cart.preloadTinyCart();
    }
    else if (action === AddToCartActionOption.MINI_CART) {
        return ecomPlatformPublicAPI.cart.preloadSideCart();
    }
    else if (action === AddToCartActionOption.CART) {
        return ecomPlatformPublicAPI.cart.preloadCartPage();
    }
}
export function calculateAddToCartCartAction(requestedAddToCartCartAction, hasCartIcon) {
    if (requestedAddToCartCartAction === AddToCartActionOption.NONE && !hasCartIcon) {
        return AddToCartActionOption.MINI_CART;
    }
    return requestedAddToCartCartAction !== null && requestedAddToCartCartAction !== void 0 ? requestedAddToCartCartAction : AddToCartActionOption.MINI_CART;
}
export function handleAddToCartAction(ecomPlatformPublicAPI, addToCartAction, addedProductId) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(addToCartAction === AddToCartActionOption.MINI_CART)) return [3 /*break*/, 5];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ecomPlatformPublicAPI.cart.openSideCart()];
                case 2: return [2 /*return*/, _c.sent()];
                case 3:
                    _a = _c.sent();
                    return [2 /*return*/, ecomPlatformPublicAPI.navigate.toCart()];
                case 4: return [3 /*break*/, 11];
                case 5:
                    if (!(addToCartAction === AddToCartActionOption.TINY_CART)) return [3 /*break*/, 10];
                    _c.label = 6;
                case 6:
                    _c.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, ecomPlatformPublicAPI.cart.showTinycart({ addedProductId: addedProductId })];
                case 7: return [2 /*return*/, _c.sent()];
                case 8:
                    _b = _c.sent();
                    return [2 /*return*/, ecomPlatformPublicAPI.navigate.toCart()];
                case 9: return [3 /*break*/, 11];
                case 10:
                    if (addToCartAction === AddToCartActionOption.CART) {
                        return [2 /*return*/, ecomPlatformPublicAPI.navigate.toCart()];
                    }
                    _c.label = 11;
                case 11: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=addToCart.utils.js.map